import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Tabs, Tab } from "react-bootstrap";
import "./index.css";
import { useDispatch } from "react-redux";
import UserCompanyInfo from "./UserCompanyInfo";
import UserBankingInfo from "./UserBankingInfo";
import UserFactoryInfo from "./UserFactoryInfo";
import UserAddressInfo from "./UserAddress";
import { stringConstants } from "../../../../helpers";
import UserLP from "./UserLP";
import VehicleInfo from "./VehicleInfo";
import SellerPayouts from "./SellerPayouts";
import SellerSubscription from "./SellerSubscription";

const UserDetails = ({ userId, userObj }) => {
  const dispatch = useDispatch();
  const [tabKey, setTabKey] = useState("companyInfo");

  useEffect(() => {
    // console.log("UserId: ", userId);
  }, [userId]);

  useEffect(() => {
    // console.log("UserObj: ", userObj);
  }, [userObj]);

  return (
    <>
      <Container className="bhree-admin-user-list p-0">
        {userObj?.role?.role_name === stringConstants.ROLL_SELLER && (
          <Tabs id="offer-tabs" activeKey={tabKey} onSelect={(k) => setTabKey(k)} className="mb-0">
            <Tab eventKey="companyInfo" title={`Company Info`}>
              <UserCompanyInfo userId={userId} userObj={userObj} />
            </Tab>
            <Tab eventKey="bankingInfo" title={`Banking Info`}>
              <UserBankingInfo userId={userId} userObj={userObj} />
            </Tab>
            {userObj?.roles_type?.role_type_name === stringConstants.ROLL_TYPE_MANUFACTURER && (
              <Tab eventKey="factoryInfo" title={`Factory Info`}>
                <UserFactoryInfo userId={userId} userObj={userObj} />
              </Tab>
            )}
            <Tab eventKey="address" title={`Address`}>
              <UserAddressInfo userId={userId} userObj={userObj} />
            </Tab>
            <Tab eventKey="subscriptionInfo" title={`Subscription Info`}>
              <SellerSubscription userId={userId} userObj={userObj} />
            </Tab>
            <Tab eventKey="payouts" title={`Payouts`}>
              <SellerPayouts userId={userId} userObj={userObj} />
            </Tab>
          </Tabs>
        )}
        {userObj?.role?.role_name === stringConstants.ROLL_BUYER && (
          <Tabs id="offer-tabs" activeKey={tabKey} onSelect={(k) => setTabKey(k)} className="mb-0">
            <Tab eventKey="companyInfo" title={`Business Information`}>
              <UserCompanyInfo userId={userId} userObj={userObj} />
            </Tab>
            <Tab eventKey="address" title={`Address`}>
              <UserAddressInfo userId={userId} userObj={userObj} />
            </Tab>
          </Tabs>
        )}
        {userObj?.role?.role_name === stringConstants.ROLL_BHAREE && (
          <p className="m-0 p-0">Work in progress...</p>
        )}
        {userObj?.roleName === stringConstants.ROLL_LOGISTIC_PARTNER && (
          <Tabs id="offer-tabs" activeKey={tabKey} onSelect={(k) => setTabKey(k)} className="mb-0">
            <Tab eventKey="companyInfo" title={`User & Main Vehicle Info`}>
              <UserLP userId={userObj.id} propUserObj={userObj} />
            </Tab>
            <Tab eventKey="vehicleInfo" title={`Other Vehicles`}>
              <VehicleInfo userId={userObj.id} />
            </Tab>
            <Tab eventKey="bankingInfo" title={`Banking Info`}>
              <UserBankingInfo userId={userObj.id} userObj={userObj} />
            </Tab>
          </Tabs>
        )}
      </Container>
    </>
  );
};

export default UserDetails;
